import { createAxiosInstance, guid } from '../utils/helpers'
import { API_URL } from './index'
import * as types from './types'
import { displayMessages } from './common'

export function getParametros() {
	return dispatch => {
		const axios = createAxiosInstance()
		axios.get(`${API_URL}/admin/parametros`)
		.then((res) => {
			const data = res.data.map(x => {
				x.visible = true
				x.selected = false
				x.parametro_cols.map(y => {
					y.guid = guid()
					return y
				})
				return x
			})

			const fn1 = d => d({ type: types.OBTENER_ADMIN_PARAMETROS, payload: data })
			fn1(dispatch)
		})
		.catch((err) => {
			console.log(err)
			displayMessages(dispatch, err)
		})
	}
}

export function toggleSelectItem(id, checked) {
	return (dispatch, getState) => {
		const index = getState().parametros.get('parametros').findIndex(x => x.get('id') === id)
		dispatch({ type: types.CONMUTAR_SELECCION_ADMIN_PARAMETRO, payload: { index, checked } })
	}
}

export function toggleSelectAllItems(checked) {
	return (dispatch) => {
		dispatch({ type: types.CONMUTAR_SELECCION_TODOS_ADMIN_PARAMETROS, payload: checked })
	}
}

export function filterParametros(term) {
	return (dispatch) => {
		dispatch({ type: types.FILTRAR_ADMIN_PARAMETROS, payload: term })
	}
}

export function setOrderBy(field) {
	return (dispatch, getState) => {
		let current = getState().parametros.get('orderBy')
		current = current.set('field', field.Value)
		if (field === null) {
			current = current.set('asc', false)
		} else {
			current = current.set('asc', !current.get('asc'))
		}
		dispatch({ type: types.ORDENAR_ADMIN_PARAMETROS, payload: { orderBy: current } })
	}
}

export function displayModalCreate(show, title, mode, id) {
	return (dispatch, getState) => {
		const user = getState().common.get('user')
		dispatch({ type: types.MOSTRAR_MODAL_CREAR_ADMIN_PARAMETRO, payload: { show, title, mode, id, user } })
	}
}

export function updateInputs(path, value) {
	return (dispatch) => {
		dispatch({ type: types.MODIFICAR_INPUTS_MODAL_CREATE_ADMIN_PARAMETROS, payload: { path, value } })
	}
}

export function createOrUpdateParametros(data, mode) {
	const axios = createAxiosInstance()
	return (dispatch) => {
		const fn0 = (d) => d({ type: types.DESHABILITAR_BOTON_MODAL_ADMIN_PARAMETROS, payload: true })
		const fn1 = (d) => d({ type: types.DESHABILITAR_BOTON_MODAL_ADMIN_PARAMETROS, payload: false })
		fn0(dispatch)
		if (mode === 'create') {
			axios.post(`${API_URL}/admin/parametros`, data.toJS())
				.then(res => {
					const parametro = res.data
					parametro.visible = true
					parametro.selected = false
					parametro.parametro_cols.map(y => {
						y.guid = guid()
						return y
					})
					dispatch({ type: types.CREAR_ACTUALIZAR_ADMIN_PARAMETRO, payload: parametro })
					displayMessages(dispatch, { success: 'El parametro ha sido guardado exitosamente' })
					fn1(dispatch)
				})
				.catch(err => {
					console.log(err)
					displayMessages(dispatch, err)
					fn1(dispatch)
				})
		} else if (mode === 'edit') {
			axios.put(`${API_URL}/admin/parametros/${data.get('id')}`, data.toJS())
				.then(res => {
					const parametro = res.data
					parametro.visible = true
					parametro.selected = false
					parametro.parametro_cols.map(y => {
						y.guid = guid()
						return y
					})
					dispatch({ type: types.CREAR_ACTUALIZAR_ADMIN_PARAMETRO, payload: parametro })
					displayMessages(dispatch, { success: 'El parametro ha sido actualizado exitosamente' })
					fn1(dispatch)
				})
				.catch(err => {
					console.log(err)
					displayMessages(dispatch, err)
					fn1(dispatch)
				})
		}
	}
}

export function showHideModalDelete(open, message = null, action = null) {
	return (dispatch) => {
		dispatch({ type: types.MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_ADMIN_PARAMETRO, payload: { open, message, action } })
	}
}

export function deleteParametros() {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {
		const selected = getState().parametros.get('parametros').filter(x => x.get('selected')).map(x => x.get('id'))
		const fns = []
		selected.forEach(x => {
			const fn = () => axios.delete(`${API_URL}/admin/parametros/${x}`)
			fns.push(fn)
		})

		const toResultObject = (promise) => {
			return promise
			.then(result => ({ success: true, result }))
			.catch(error => ({ success: false, error }));
		}

		Promise.all(fns.map(x => x()).map(toResultObject))
		.then(res => {
			const succeded = []
			const failed = []
			res.forEach(x => {
				if (!x.success) {
					failed.push(x.error.response.data.ExceptionMessage)
				} else {
					succeded.push(x.result.data.Nombre)
					dispatch({ type: types.ELIMINAR_ADMIN_PARAMETRO, payload: x.result.data.id })
				}
			})
			if (succeded.length > 0) displayMessages(dispatch, { success: 'Se han eliminado los siguentes parametros: ' + succeded.join(', ') })
			if (failed.length > 0) displayMessages(dispatch, { response: { status: 500, data: failed.join('\n') } })
		})
	}
}

export function addParametroConfig() {
	return (dispatch) => {
		dispatch({ type: types.ADICIONAR_NUEVA_CONFIGURACION_ADMIN_PARAMETRO })
	}
}

export function removeParametrosConfig(id) {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {
		const selected = getState().parametros.getIn(['modalCreate', 'data', 'parametro_cols']).filter(x => x.get('id') !== null && x.get('selected')).map(x => x.get('id'))
		const fns = []
		selected.forEach(x => {
			const fn = () => axios.delete(`${API_URL}/admin/parametros/${id}/configuracion/${x}`)
			fns.push(fn)
		})

		const toResultObject = (promise) => {
			return promise
			.then(result => ({ success: true, result }))
			.catch(error => ({ success: false, error }));
		}

		Promise.all(fns.map(x => x()).map(toResultObject))
		.then(res => {
			const failed = []
			res.forEach(x => {
				if (!x.success) {
					failed.push(x.error.response.data.ExceptionMessage)
				}
			})
			if (failed.length > 0) displayMessages(dispatch, { response: { status: 500, data: failed.join('\n') } })
		})

		dispatch({ type: types.ELIMINAR_CONFIGURACION_ADMIN_PARAMETRO })
	}
}



// WEBPACK FOOTER //
// ./src/actions/parametros.js